import React, { FC, memo } from 'react';
import { Button, Form } from 'react-bootstrap';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import cls from './PaginationBar.module.scss';

export const PAGE_SIZES = [10, 20, 50, 100];

type PaginationBarProps = {
  /** Zero-based, as the backend counts pages */
  page: number;
  size: number;
  countAll: number;
  onPageChange: (page: number) => void;
  onSizeChange: (size: number) => void;
  /** Plural noun for the counter, e.g. "styles" */
  itemsName: string;
};

const PaginationBar: FC<PaginationBarProps> = memo((props) => {
  const { page, size, countAll, onPageChange, onSizeChange, itemsName } = props;
  const lastPage = Math.max(Math.ceil(countAll / size) - 1, 0);
  const firstShown = countAll === 0 ? 0 : page * size + 1;
  const lastShown = Math.min((page + 1) * size, countAll);
  return (
    <div className={cls.Pagination} data-testid="pagination-bar">
      <span className={cls.Counter}>
        {`${firstShown}–${lastShown} of ${countAll} ${itemsName}`}
      </span>
      <div className={cls.Controls}>
        <Form.Select
          value={size}
          onChange={(event) => onSizeChange(Number(event.target.value))}
          className={cls.SizeSelect}
          aria-label="Rows per page"
        >
          {PAGE_SIZES.map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              {`${pageSize} per page`}
            </option>
          ))}
        </Form.Select>
        <Button
          className={cls.PageButton}
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 0}
          aria-label="Previous page"
        >
          <MdChevronLeft />
        </Button>
        <span className={cls.PageNumber}>{`${page + 1} / ${lastPage + 1}`}</span>
        <Button
          className={cls.PageButton}
          onClick={() => onPageChange(page + 1)}
          disabled={page >= lastPage}
          aria-label="Next page"
        >
          <MdChevronRight />
        </Button>
      </div>
    </div>
  );
});

export default PaginationBar;
